// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"32344316","348":"48c99f5d","543":"600de4e7"}[chunkId] + ".chunk.js";
};